import { StringHelpers } from "../helpers/string-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { IComponent } from "./component.interface";
import { PnlComponent } from "./pnl.component";

export class EarningNotificationComponent implements IComponent {
    public id = '';

    private element: HTMLElement;
    private base: IChartContainer;
    private resizeTimer: any;
    
    constructor(element: HTMLElement, base: IChartContainer) {
        this.element = element;
        this.base = base;
        this.subscribeEarningNotification();
        this.onResize();
    }

    public show() {
        this.element.removeClass('hidden');
    }

    public hide() {
        this.element.addClass('hidden');
    }

    private updateText(text: string) {
        this.element.findFirst('.text')?.setInnerHtml(text);
        this.element.findFirst('.symbol')?.ifExistThen((el: HTMLElement) => {
            el.setAttribute('title', StringHelpers.replaceHTMLTag(text));
        });
        if (text) {
            this.show();
        }

        this.handleESymbol();
    }

    private subscribeEarningNotification() {
        this.base.chartService.subscribeEarningNotificationData((data: string) => {
            this.updateText(data);
        });
    }

    private handleESymbol() {
        this.element.findFirst('.symbol')?.addClass('hidden');
        this.element.findFirst('.text')?.removeClass('hidden');
        this.element.findFirst('.text')?.addClass('visually-hidden');

        const windowWidth = this.base.tiChartSeries.element.clientWidth;
        const elementWidth = this.element.clientWidth;
        const pnlComponent = this.base.getComponentsByType(PnlComponent)[0] as PnlComponent;
        const otherComponentsWidth = (pnlComponent?.element.clientWidth ?? 0 ) + 80;

        if (elementWidth + otherComponentsWidth > windowWidth) {
            this.element.findFirst('.symbol')?.removeClass('hidden');
            this.element.findFirst('.text')?.addClass('hidden');
        } else {
            this.element.findFirst('.text')?.removeClass('hidden');
            this.element.findFirst('.symbol')?.addClass('hidden');
        }

        this.element.findFirst('.text')?.removeClass('visually-hidden');
    }

    private onResize() {
        this.base.domEvents.onResize(() => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                this.handleESymbol();
            }, 200);
        });
    }
}